module.exports = {
  placeholder: 'Поиск по словарям',
};
